export const getTextColor = variant => {
  let color;
  switch (variant) {
    case 'primary-secondary':
    case 'ai':
      color = 'primary-default';
      break;
    case 'primary-tertiary':
    case 'ai-tertiary':
      color = 'information-default';
      break;
    case 'destructive-secondary':
    case 'destructive-tertiary':
      color = 'negative-hover';
      break;
    case 'upgrade-secondary':
    case 'upgrade-tertiary':
      color = 'upgrade-press';
      break;
    case 'subtle':
      color = 'content-primary';
      break;
    default:
      color = 'content-white';
  }
  return color;
};